import { Delete, Edit } from "@mui/icons-material";
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import { Backdrop, Box, Button, LinearProgress, Modal, Tooltip, Typography } from "@mui/material";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { MyToDisableForm } from "../../components";
import { MyRenderCell } from "../../components/MyRenderCell";
import { createEntityToDisable, IEntityToDisable } from "../../models/entityToDisable";
import { createSubActivity, ISubActivity } from "../../models/subActivities";
import { disableSubActivity, getSubActivities } from "../../redux";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { RootState } from '../../redux/store';
import { MyBoxModal } from "../../styled-components";
import { MyForm } from './components';

interface Props {
    idActivity?: string;
    isToAddSubActivities?: boolean;
}

export const SubActivities = ({ isToAddSubActivities, idActivity }: Props) => {
    const navigate = useNavigate();

    const [dialogOpen, setDialogOpen] = useState(false);
    const openDialog = () => setDialogOpen(!dialogOpen);

    const [deleteOpen, setDeleteOpen] = useState(false);
    const openDeleteDialog = () => setDeleteOpen(!deleteOpen);

    const [editing, setEditing] = useState(false);

    const [subActivityToEdit, setSubActivityToEdit] = useState(createSubActivity({}));
    const [entityToDisable, setEntityToDisable] = useState(createEntityToDisable({}));

    const [pageSize, setPageSize] = useState<number>(50);

    const dispatch = useAppDispatch();
    const { isLoading, subActivities = [] } = useAppSelector((state: RootState) => state.subActivities);

    useEffect(() => {
        dispatch(getSubActivities(idActivity) as any);
    }, [dispatch, idActivity])

    const onDelete = (subActivity: ISubActivity) => {
        setEntityToDisable(createEntityToDisable(subActivity));
        setEditing(true);
        openDeleteDialog();
    }

    const onEdit = (subActivity: ISubActivity) => {
        setSubActivityToEdit(createSubActivity(subActivity));
        setEditing(true);
        openDialog();
    }

    const onCreate = () => {
        setSubActivityToEdit(createSubActivity({}));
        setEditing(false);
        openDialog();
    }

    const onDisable = (values: IEntityToDisable) => {
        dispatch(disableSubActivity(values) as any);
    }

    const Columns: GridColDef[] = [
        {
            field: "action",
            headerName: "Actions",
            width: 210,
            sortable: false,
            align: "right",
            renderCell: (params) => {
                const onClick = (e: React.MouseEvent<HTMLElement>) => {

                    onEdit(params.row as any);
                };
                const deleteSubActivity = (e: React.MouseEvent<HTMLElement>) => {

                    onDelete(params.row as any);
                };
                const addItems = (e: React.MouseEvent<HTMLElement>) => {

                    navigate("/subActivities/" + params.row.id);
                }
                return (
                    <>
                        <Tooltip title="Edit" >
                            <Button onClick={onClick}><Edit /></Button>
                        </Tooltip>
                        <Tooltip title="Delete" >
                            <Button onClick={deleteSubActivity}><Delete /></Button>
                        </Tooltip>
                        <Tooltip title="Add Items" >
                            <Button onClick={addItems}><FormatListNumberedIcon /></Button>
                        </Tooltip>
                    </>
                )
            }
        },
        {
            field: 'id',
            headerName: 'id',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'name',
            headerName: 'Name',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'activityName',
            headerName: 'Activity',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'activeUntilDate',
            headerName: 'Active Until Date',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
    ]

    return (
        <div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <Box sx={{ width: '40%' }}>
                    <LinearProgress />
                </Box>
            </Backdrop>
            {!isToAddSubActivities && (
                <>
                    <Typography variant="h4" component="h1">Sub Activities</Typography>
                    <br />
                    <Button onClick={onCreate}>Add</Button>
                </>
            )}
            <div style={{ height: "calc(100vh - 250px)", width: '100%', flexGrow: 1 }}>
                <DataGrid
                    rows={subActivities}
                    columns={Columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 50, 100]}
                    columnVisibilityModel={{ id: false, }}
                //checkboxSelection
                />
            </div>
            <Modal open={dialogOpen} onClose={openDialog}>
                <MyBoxModal>
                    <MyForm onCancel={openDialog} subActivity={subActivityToEdit} editing={editing} />
                </MyBoxModal>
            </Modal>
            <Modal open={deleteOpen} onClose={openDeleteDialog}>
                <MyBoxModal>
                    <MyToDisableForm onCancel={openDeleteDialog} entity={entityToDisable} onDisable={onDisable} />
                </MyBoxModal>
            </Modal>
        </div >
    )
}
